'use client';

import { ReactErrorType, reportReactError } from '@actr/logger';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { SiteError } from '@actr/widgets/src/components/_misc/error-boundary/site-error';
import * as Styled from '@actr/widgets/src/components/_misc/error-boundary/style.css';
import { useEffect } from 'react';

const ERROR_TEXT = 'К сожалению при отображении этой страницы произошла ошибка'
  + ', Вы можете вернуться на главную страницу сайта или обратиться в техподдержку.';

export type NextErrorBoundaryProps = {
  error: Error & { digest?: string };
  reset: () => void;
}

const NextErrorBoundary = ({ error, reset }: NextErrorBoundaryProps) => {
  useEffect(() => {
    reportReactError(ReactErrorType.CAUGHT, error, { componentStack: null });
  }, [error]);

  function handleClickMainPage() {
    if (window.location.pathname === '/') {
      reset();

      return;
    }

    window.location.href = '/';
  }

  return (
    <SiteError>
      <section aria-live="assertive" role="alert">
        <div>{ERROR_TEXT}</div>
        <div className={Styled.ButtonsBlock}>
          <Button size={ButtonSizes.L} buttonType={ButtonTypes.BRAND} onClick={handleClickMainPage}>
            На главную страницу
          </Button>
        </div>
      </section>
    </SiteError>
  );
};

export default NextErrorBoundary;
